var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconTlc = function SvgIconTlc(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8422 11.548L24.1762 10.415C25.1102 9.96203 26.2362 10.351 26.6902 11.286C26.8072 11.529 26.8722 11.793 26.8782 12.063C26.8942 12.725 26.9022 13.393 26.9022 14.063C26.9022 14.76 26.8932 15.451 26.8762 16.138C26.8502 17.177 25.9872 17.998 24.9492 17.972C24.6952 17.966 24.4442 17.908 24.2132 17.802L21.9282 16.758C21.3032 16.472 20.8842 15.865 20.8392 15.178L20.8342 15.096C20.7892 14.408 20.7912 13.719 20.8392 13.032C20.8842 12.393 21.2672 11.827 21.8432 11.548H21.8422Z",
    fill: "#343434"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5006 5C9.62127 5 7.7431 5.135 5.86493 5.4095C4.2207 5.648 3 7.07675 3 8.762V18.7902C3 20.2707 3.94795 21.5802 5.3405 22.0224C7.39385 22.6737 9.4472 23 11.5006 23C13.5528 23 15.6062 22.6749 17.6595 22.0224C19.052 21.5802 20 20.2707 20 18.7902V8.762C20 7.07675 18.7793 5.648 17.1362 5.4095C15.2569 5.13612 13.3787 5 11.5006 5ZM16.902 9.5C16.902 10.3284 16.2304 11 15.402 11C14.5736 11 13.902 10.3284 13.902 9.5C13.902 8.67157 14.5736 8 15.402 8C16.2304 8 16.902 8.67157 16.902 9.5Z",
    fill: "#343434"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconTlc);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "icon-tlc.a972dcc600c5c6f5732bb91488ad6e83.svg";